export default __webpack_public_path__ + "static/media/step 4.75c57c7e.png";